enum OperatingLeaseProductsPersonEnum {
    OL01 = "OL01",
    OL24 = "OL24",
    OL36 = "OL36",
    OL48 = "OL48",
}

export default OperatingLeaseProductsPersonEnum;
